import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import PersonIcon from "@mui/icons-material/Person";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BathtubIcon from "@mui/icons-material/Bathtub";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import { mainDataHomeText } from "../styles";
import { KingBed } from "@mui/icons-material";
import DonutLargeIcon from "@mui/icons-material/DonutLarge";
import { Link } from "react-router-dom";

function HomeCardComponent({ data, type = "project" }) {
  return (
    <Grid item xs={3} sm={1.5} md={1} lg={1}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "rgba(242, 242, 242, 0.35)",
          borderRadius: 4,
        }}
      >
        <Stack
          component="article"
          sx={{
            width: "100%", // Anchura fija
            height: 200,
            mb: 1,
          }}
        >
          <img
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              aspectRatio: "1/1",
              borderRadius: "8px",
            }}
            src={
              data.photo_profile[0].url ||
              "https://as1.ftcdn.net/v2/jpg/06/00/88/96/1000_F_600889685_N2bnfSBEyYDNW6tExn2riTS9McpnFWew.jpg"
            }
            alt="Property | Projects"
          />
        </Stack>
        <Stack
          component="article"
          position="relative"
          sx={{
            overflowX: "hidden",
          }} // Ajusta el ancho para tener en cuenta el width fijo de la imagen
        >
          <Typography
            component="h2"
            variant="h6"
            sx={{
              textTransform: "capitalize",
              display: "block",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              fontWeight: 700,
              fontFamily: "Inter",
              fontSize: "medium",
              mb: 1,
            }}
          >
            {data.name}
          </Typography>
          <Typography
            sx={{
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              WebkitLineClamp: 2, // Ajusta el número de líneas visibles aquí
              lineHeight: "1.5em",
              fontSize: "small",
              fontWeight: "normal",
              mb: 2,
            }}
            variant="subtitle2"
          >
            {data.information}
          </Typography>
          <Stack
            width="100%"
            marginInline="auto"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="flex-end"
            bottom={{ xs: 3, md: 0 }}
          >
            <Typography component="span">
              €{" "}
              {type === "project"
                ? parseInt(data.objective).toLocaleString("es-CO")
                : parseInt(data.price).toLocaleString("es-CO")}
            </Typography>
            <Button
              LinkComponent={Link}
              to={
                type === "project"
                  ? `/details/project/${data.id}`
                  : `/details/property/${data.id}`
              }
              variant="contained"
              size="small"
              sx={{ fontSize: "small", textTransform: "none" }}
            >
              Detalles
            </Button>
            {/* <Typography component="span" sx={{ ...mainDataHomeText }}>
              <LocalAtmIcon />
              {data.data.price
                ? parseInt(data.data.price).toLocaleString("es-CO")
                : parseInt(data.data.objective).toLocaleString("es-CO")}
            </Typography>
            <Typography component="span" sx={{ ...mainDataHomeText }}>
              {data.type === "property" ? <KingBed /> : <PersonIcon />}
              {data.data.bedrooms || data.data.cant_investors}
            </Typography>
            <Typography component="span" sx={{ ...mainDataHomeText }}>
              {data.type === "property" ? (
                <AspectRatioIcon />
              ) : (
                <AccessTimeIcon />
              )}
              {data.data.m2 || data.data.remaindingDays}
            </Typography>
            <Typography component="span" sx={{ ...mainDataHomeText }}>
              {data.type === "property" ? <BathtubIcon /> : <DonutLargeIcon />}
              {data.data.bathrooms || data.data.completed + "%"}
            </Typography> */}
          </Stack>
        </Stack>
      </Box>
    </Grid>
  );
}

export default HomeCardComponent;
